<template>
  <div id="tuku">
    <h1 style="text-align: center">图库大全</h1>
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="waterfall">
        <div>
          <div v-for="item in leftItems" :key="item.id" class="waterfall-item">
            <van-image
              :src="item.pictureUrl"
              width="100%"
              height="auto"
              fit="cover"
              lazy-load
              class="image"
              @click="showImagePreview([item.pictureUrl])"
            />
          </div>
        </div>
        <div>
          <div v-for="item in rightItems" :key="item.id" class="waterfall-item">
            <van-image
              :src="item.pictureUrl"
              width="100%"
              height="auto"
              fit="cover"
              lazy-load
              class="image"
              @click="showImagePreview([item.pictureUrl])"
            />
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { drawHttp } from "../request/index";
import { showImagePreview } from "vant";

const loading = ref(false); // 是否正在加载
const finished = ref(false); // 是否已全部加载完成
const listPicture = ref([]); // 图片列表
const page = ref(0); // 当前页码

// 获取图片列表数据
async function getlistPicture() {
  try {
    const res = await drawHttp({
      method: "get",
      url: `/gallerynew/h5/index/listPicture?pageNum=${page.value}&Lotterytype=2`,
    });

    // 假设返回的数据结构为 { list: [...] }，根据实际接口调整
    const newList = res.list || [];
    listPicture.value.push(...newList);

    // 如果返回的数据不足一页，说明没有更多了
    if (newList.length === 0) {
      finished.value = true;
    }
  } catch (error) {
    console.error("加载失败", error);
    // 可根据需要处理错误提示
  } finally {
    loading.value = false; // 无论成功或失败，结束加载状态
  }
}
const leftItems = computed(() =>
  listPicture.value.filter((_, index) => index % 2 === 0)
);
const rightItems = computed(() =>
  listPicture.value.filter((_, index) => index % 2 === 1)
);

// 滚动到底部时触发
function onLoad() {
  page.value++; // 页码+1
  loading.value = true; // 开始加载
  getlistPicture();
}
</script>

<style scoped lang="scss">
.waterfall {
  display: flex;
  padding: 8px;
  flex-wrap: wrap;
  box-sizing: border-box;
  grid-gap: 10px;
  > div {
    flex: 1;
  }
}

.waterfall-item {
  break-inside: avoid; /* 避免图片跨列断裂 */
  margin-bottom: 12px; /* 项间距 */
  border-radius: 8px;
  overflow: hidden;
  background-color: #f5f5f5; /* 占位背景色，提升加载体验 */
  margin-bottom: 10px;
}

.image {
  display: block;
  width: 100%;
  height: auto;
  transition: opacity 0.2s;
}

/* 可选：图片加载完成后的微效果 */
.van-image__img {
  background-color: #eee;
}
</style>